import { debounce } from 'lodash-es';
import {
    ContentZone,
    ContentZoneComponentConfig,
    ContentZoneComponentModel,
    DisplayType,
    HawkSearchComponents,
    HawkSearchGlobal,
    SearchResponse
} from '@models';
import { BaseComponent } from '../../base.component';
import { ImageContentComponent } from '../content-types';
import defaultHtml from './content-zone.component.hbs';

declare let HawkSearch: HawkSearchGlobal;

export class ContentZoneComponent extends BaseComponent<ContentZoneComponentConfig, SearchResponse, ContentZoneComponentModel> {
    protected override componentName: keyof HawkSearchComponents = 'content-zone';
    protected override defaultHtml = defaultHtml;
    protected override bindFromEvent = true;

    private get name(): string | undefined {
        return this.getAttribute('name') || undefined;
    }

    private get zone(): ContentZone | undefined {
        return this.name ? this.data?.contentZones?.[this.name] : undefined;
    }

    private get displayType(): DisplayType {
        const width = window.innerWidth;

        if (width >= (HawkSearch.config.breakpoints?.desktop ?? 990)) {
            return 'desktop';
        } else if (width >= (HawkSearch.config.breakpoints?.tablet ?? 740)) {
            return 'tablet';
        } else {
            return 'mobile';
        }
    }

    private previousDisplayType?: DisplayType;

    private windowResizeEventHandler!: (event: Event) => void;

    override connectedCallback(): void {
        super.connectedCallback();

        this.windowResizeEventHandler = debounce((event: Event): void => {
            if (this.displayType === this.previousDisplayType) {
                return;
            }

            this.render();
        }, 100);

        window.addEventListener('resize', this.windowResizeEventHandler);
    }

    disconnectedCallback(): void {
        super.disconnectedCallback();

        window.removeEventListener('resize', this.windowResizeEventHandler);
    }

    protected override renderContent(): boolean {
        return !!this.zone?.items?.length;
    }

    protected override getContentModel(): ContentZoneComponentModel {
        this.previousDisplayType = this.displayType;

        return {
            ...this.zone!,
            items: this.zone?.items.map((i) => i[this.displayType]) ?? []
        };
    }

    protected bindChildElements(): void {
        this.rootElement.querySelectorAll('[index]').forEach((e) => {
            const component = e as ImageContentComponent;
            const index = parseInt(component.getAttribute('index') || '-1');

            if (isNaN(index) || index < 0 || index >= (this.zone?.items.length || -1)) {
                return;
            }

            component.data = this.zone?.items[index]?.[this.displayType] as any;
        });
    }
}
